import React from 'react'

const DateWidget = function (props) {
  const { value, options, required, onChange } = props

  return (
    <input
      className="form-control"
      type="date"
      label="MemberUntil"
      value={value || ''}
      min={options.min}
      max={options.max}
      required={required}
      pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
      onChange={(event) => onChange(event.target.value)}
    />
  )
}

export default DateWidget
